export default {"src":"/_next/static/media/rs.2f7fbce3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};